import { render, staticRenderFns } from "./dialog-forget-psw.vue?vue&type=template&id=5a63de34&"
import script from "./dialog-forget-psw.vue?vue&type=script&lang=js&"
export * from "./dialog-forget-psw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports